import { MenuItem, Select } from '@material-ui/core';
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getProductsInformation,
  getShopingCards
} from '../../action'
import { ProductInfoItem, ShopingCard } from '../../components';
import './style.scss'
class Products extends Component {

  componentDidMount() {
    this.props.getProductsInformation();
    this.props.getShopingCards();
  }

  render() {
    const { products: { productInformation, productsCarts } } = this.props;
    const activeItem = 0;
    return (
      <div className="products-page">
        <div className="information-part">
          {
            Array.isArray(productInformation) && productInformation.map((information, index) => (
              <React.Fragment key={index}>
                <div className={`title${index === activeItem ? ' active' : ''}`}>{information.label}</div>
                <div className="content">
                  {

                    Array.isArray(information.values) && information.values.map((element, index) => (
                      <ProductInfoItem {...element}  key={index} />
                    ))
                  }
                </div>
              </React.Fragment>
            ))
          }
        </div>
        <div className="product-showcase">
          <div className="infomations">
            <div className="greeting">Boa tarde, 116 Guarapari!</div>
            <div className="date">Sexta-feira, 28 de Agosto de 2020</div>
            <div className="description">Pedidos comprados para recebimento em Outubro de 2020 (fechado)</div>
            <div className="dropdown">
              <Select fullWidth defaultValue={0}>
                <MenuItem value={0}>Selecione o período do showroom</MenuItem>
                <MenuItem value={1}>ShowRoom 1</MenuItem>
                <MenuItem value={2}>ShowRoom 2</MenuItem>
              </Select>
            </div>
          </div>
          <div className="lists-info"><br/>
            Mostrando 1-40 do 339 resultados
          </div>
          <div className="card-lists">
            {
              Array.isArray(productsCarts) && productsCarts.map((element, index) => (
                <ShopingCard {...element} key={index} onClick={() => this.props.history.push(`/productitem/${element.ref}`)} />
              ))
            }
          </div>
        </div>
      </div>

    )
  }
}

const mapStateToProps = ({ products }) => ({
  products
})

export default connect(mapStateToProps, {
  getProductsInformation,
  getShopingCards,
})(Products)